import { render, staticRenderFns } from "./ModalPersonal.vue?vue&type=template&id=205e7c11"
import script from "./ModalPersonal.vue?vue&type=script&lang=js"
export * from "./ModalPersonal.vue?vue&type=script&lang=js"
import style0 from "./ModalPersonal.vue?vue&type=style&index=0&id=205e7c11&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports